export const environment = {
  IsProduction: false,
  IsHero: false,
  environment: 'dev',
  launchDarklyClientId: '664590c02c638010dc55095f',
  oneTimeTokenName: 'fenixOneTimeToken',
  homepage: 'https://analyzer.testtools.devtest.gf.aws.scania.com/',
  redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login',
};

export const webAnalytics = {
  stagingUri:
    'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
  releaseUri:
    'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql',
};

export const authentication = {
  authLayerStagingUrl:
    'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
  authLayerReleaseUrl:
    'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql',
};

export const menuUrls = {
  supportUrl:
    'https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
  homeUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com',
};
